<button mat-icon-button *ngIf="entitledForAdvisorInfo; else AboutUs" class="fw-Header_Icons" [matMenuTriggerFor]="advisorPanel"
    (menuClosed)="isActive = false" (menuOpened)="isActive = true" [class.active]="isActive"
    matTooltip="{{'NXI_PORTAL_COMPONENTS.CONTACT_US' | translate}}"
    attr.aria-label="{{'NXI_PORTAL_COMPONENTS.CONTACT_US' | translate}}" [attr.aria-haspopup]="contactUsAriaHasPopup">
    <div class="fw-Header_ContactUsIcon"></div>
</button>

<ng-template #AboutUs>
    <button mat-icon-button class="fw-Header_Icons" (click)="contactUs()"
        matTooltip="{{'NXI_PORTAL_COMPONENTS.CONTACT_US' | translate}}">
        <div class="fw-Header_ContactUsIcon"></div>
    </button>
</ng-template>

<mat-menu xPosition="before" class="fw-Advisor_Menu" #advisorPanel="matMenu" role="menu" aria-label="{{'NXI_PORTAL_COMPONENTS.ADVISOR_MENU' | translate}}">
    <ng-template matMenuContent>
        <advisor-info (click)="$event.stopPropagation()" role="menuitem" tabindex="0"></advisor-info>
        <ng-container *ngIf="entitledForAboutUs">
            <hr aria-hidden="true">
            <button mat-menu-item (click)="contactUs()" (keydown.enter)="contactUs()" tabindex="0" role="menuitem">
                {{'ADVISOR.MOREABOUTUS' | translate }}
            </button>
        </ng-container>
    </ng-template>
</mat-menu>